module.exports = __webpack_public_path__ + "static/media/submitOutputData.c3faf8f7.svg";